package io.janni.wedding.viewmodels

import androidx.compose.runtime.*
import androidx.lifecycle.ViewModel
import kotlinx.coroutines.coroutineScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.first
import kotlinx.coroutines.isActive
import kotlinx.coroutines.launch

// List of all wedding photos for the slideshow
val backgroundImages = listOf(
    "devries-48.jpg",
    "devries-111.jpg",
    "devries-120.jpg",
    "devries-126.jpg",
    "devries-134.jpg",
    "devries-213.jpg",
    "devries-220.jpg",
    "devries-236.jpg"
)

// ViewModel for managing slideshow state
class SlideshowViewModel: ViewModel() {
    private var _currentImageIndex by mutableStateOf(0)
    private var _layerAIndex by mutableStateOf(0)
    private var _layerBIndex by mutableStateOf(0)
    private var _showLayerA by mutableStateOf(true)

    val currentImageIndex: Int get() = _currentImageIndex
    val layerAIndex: Int get() = _layerAIndex
    val layerBIndex: Int get() = _layerBIndex
    val showLayerA: Boolean get() = _showLayerA
    val timer: MutableIntState = mutableIntStateOf(0)
    val awaitTime: Int get() = 3000

    private fun resetTimer() {
        timer.intValue = 0
    }

    suspend fun startSlideshow() {
        while (true) {
            nextImageWithTimer()
        }
    }

    private suspend fun nextImageWithTimer(): Unit = coroutineScope {
        val counterJob = launch {
            while (isActive) {
                delay(1)
                timer.intValue++
            }
        }

        snapshotFlow { timer.intValue }
            .first { it >= awaitTime}

        counterJob.cancel()
        nextImage()
    }

    fun nextImage() {
        resetTimer()
        _currentImageIndex = (_currentImageIndex + 1) % backgroundImages.size
        updateTransition()
    }

    fun previousImage() {
        _currentImageIndex = if (_currentImageIndex == 0) backgroundImages.size - 1 else _currentImageIndex - 1
        updateTransition()
    }

    fun setImageIndex(index: Int) {
        _currentImageIndex = index
        updateTransition()
    }

    private fun updateTransition() {
        // Update the hidden layer with the new image, then show it
        if (_showLayerA) {
            _layerBIndex = _currentImageIndex
            _showLayerA = false
        } else {
            _layerAIndex = _currentImageIndex
            _showLayerA = true
        }
    }
}
